import React from 'react';
import R from 'ramda';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Heading from '@cotyorg/ccx-atoms/Heading';
import Paragraph from '@cotyorg/ccx-atoms/Paragraph';
import SectionHeader from '../../atoms/SectionHeader';
import StandardLayout from '../../templates/StandardLayout';

const AuthentischeBewertungen = ({ sectionsContent }) => (
  <StandardLayout>
    <div className="authentische-bewertungen-page">
      <div className="grid-container">
        <div className="grid-x">
          {!!R.prop('summary')(sectionsContent) && (
            <div className="authentische-bewertungen-page__summary">
              <Paragraph>{R.prop('summary')(sectionsContent)}</Paragraph>
            </div>
          )}

          {R.map(
            (section) => (
              <div
                id={R.prop('headingId', section)}
                key={R.prop('headingId', section)}
              >
                {!!R.prop('heading', section) && (
                  <SectionHeader isBanner textAign="left">
                    <Heading level={1}>{R.prop('heading', section)}</Heading>
                  </SectionHeader>
                )}

                {!!R.prop('introduction', section) && (
                  <Paragraph>{R.prop('introduction', section)}</Paragraph>
                )}
              </div>
            ),
            R.prop('sections', sectionsContent)
          )}
        </div>
      </div>
    </div>
  </StandardLayout>
);

AuthentischeBewertungen.propTypes = {
  sectionsContent: PropTypes.shape({
    summary: PropTypes.string,
    sections: PropTypes.arrayOf(
      PropTypes.shape({
        heading: PropTypes.string,
        heading_id: PropTypes.string,
        introduction: PropTypes.string,
      })
    ),
  }).isRequired,
};

export default connect(({ content }) => ({
  sectionsContent: R.prop('sectionsContent', content),
}))(AuthentischeBewertungen);
